// src/locales/si/offlineSales.js — Sinhala
import { offlineSales as offlineSalesEn } from '../en/offlineSales';

export const offlineSales = {
  ...offlineSalesEn,

  // Navigation / general
  posTerminal: 'POS පර්යන්තය',
  posOrders: 'POS ඇණවුම්',
  posCustomers: 'POS ගනුදෙනුකරුවන්',
  posSessions: 'මුදල් අයකැමි සැසි',
  posSettings: 'POS සැකසුම්',
  pointOfSale: 'විකුණුම් ස්ථානය',
  offlineSalesOrders: 'දුරස්ථ විකුණුම් ඇණවුම්',
  receivables: 'ලැබිය යුතු මුදල්',
  deliveryDetails: 'තොරතුරු බෙදා හැරීම',
  deliveryCity: 'බෙදා හැරීමේ නගරය',
  deliveryAddress: 'බෙදා හැරීමේ ලිපිනය',
  deliveryAddressPlaceholder: 'බෙදා හැරීමේ ලිපිනය ඇතුළත් කරන්න',
  deliveryCharge: 'බෙදා හැරීමේ ගාස්තුව',
  packageWeightKg: 'පැකේජයේ බර (kg)',
  notSet: 'සැකසී නැත',

  // Terminal top bar
  session: 'සැසිය',
  sessionOpen: 'විවෘත',
  sessionClosed: 'වසා ඇත',
  noSession: 'සැසියක් නැත',
  openSession: 'සැසිය විවෘත කරන්න',
  closeSession: 'සැසිය වසන්න',
  exitTerminal: 'පර්යන්තයෙන් ඉවත් වන්න',
  selectWarehouse: 'ගබඩාව තෝරන්න',

  // Cart
  cart: 'කරත්තය',
  emptyCart: 'කරත්තය හිස්ය',
  emptyCartHint: 'නිෂ්පාදනයක් සොයන්න හෝ එය කරත්තයට එකතු කිරීමට ස්කෑන් කරන්න',
  qty: 'ප්‍රමාණය',
  lineDiscount: 'වට්ටම',
  lineTotal: 'එකතුව',
  subtotal: 'උප එකතුව',
  itemDiscount: 'අයිතම වට්ටම්',
  loyaltyDiscount: 'පක්ෂපාතී වට්ටම',

  // Actions
  holdOrder: 'රඳවන්න',
  clearCart: 'හිස් කරන්න',
  applyDiscount: 'වට්ටම',
  redeemLoyalty: 'පක්ෂපාතී',
  charge: 'ගාස්තු කරන්න',
  completeSale: 'විකුණුම සම්පූර්ණ කරන්න',
  printReceipt: 'රිසිට්පත මුද්‍රණය කරන්න',
  newSale: 'නව විකුණුම',

  // Session gate
  sessionRequired: 'සැසිය අවශ්‍යයි',
  sessionRequiredMsg: 'විකුණුම් සැකසීමට පෙර මෙම වෙළඳසැලට විවෘත මුදල් අයකැමි සැසියක් අවශ්‍යයි.',
  openingCash: 'ආරම්භක මුදල්',
  openingCashPlaceholder: 'ලාච්චුවේ ඇති මුදල ඇතුළත් කරන්න',

  // Payment modal
  payment: 'ගෙවීම',
  cash: 'මුදල්',
  card: 'කාඩ්පත',
  bankTransfer: 'බැංකු හුවමාරුව',
  voucher: 'වවුචරය',
  loyaltyPoints: 'පක්ෂපාතී ලකුණු',
  splitPayment: 'බෙදුම් ගෙවීම',
  amountDue: 'ගෙවිය යුතු මුදල',
  amountTendered: 'ලබා දුන් මුදල',
  cashReceived: 'ලැබුණු මුදල්',
  change: 'ඉතිරි',
  remaining: 'ඉතිරිව ඇති',
  paymentReference: 'යොමුව (විකල්ප)',
  paymentComplete: 'විකුණුම සම්පූර්ණයි',
  creditSale: 'ණය විකුණුම',

  // Order discount modal
  applyOrderDiscount: 'ඇණවුම් වට්ටම යොදන්න',
  discountAmount: 'වට්ටම් මුදල',
  discountPercent: 'වට්ටම %',
  applyFlat: 'නිශ්චිත මුදල',
  applyPercent: 'ප්‍රතිශතය',

  // Loyalty modal
  loyaltyBalance: 'ලකුණු ශේෂය',
  pointsToRedeem: 'මුදාහරින ලකුණු',
  pointValue: 'ලකුණු වටිනාකම',
  discountPreview: 'වට්ටම',
  minPoints: 'අවම',
  maxDiscount: 'උපරිම වට්ටම',
  redeemPoints: 'ලකුණු මුදාහරින්න',
  removeRedemption: 'මුදාහැරීම ඉවත් කරන්න',

  // Hold orders drawer
  holdOrders: 'රඳවා ඇති ඇණවුම්',
  noHoldOrders: 'රඳවා ඇති ඇණවුම් නැත',
  recallOrder: 'නැවත ලබාගන්න',
  holdOrderNote: 'වත්මන් කරත්තය රඳවනු ලැබේ',

  // Customer selector (legacy)
  customerCity: 'නගරය',
  searchCity: 'නගරය සොයන්න...',
  loyaltyPointsLabel: 'පක්ෂපාතී ලකුණු',

  // Receipt
  receipt: 'රිසිට්පත',
  receiptTitle: 'විකුණුම් රිසිට්පත',
  orderNumber: 'ඇණවුම් #',
  date: 'දිනය',
  cashier: 'මුදල් අයකැමි',
  items: 'අයිතම',
  payments: 'ගෙවීම්',
  totalPaid: 'මුළු ගෙවීම',
  balanceDue: 'ගෙවිය යුතු ශේෂය',

  // Order list page
  allPosOrders: 'සියලුම දුරස්ථ විකුණුම් ඇණවුම්',
  viewAndManageAllOrders: 'සියලුම දුරස්ථ විකුණුම් ඇණවුම් බලා කළමනාකරණය කරන්න',
  notesPlaceholder: 'මෙම ඇණවුම පිළිබඳ සටහන් එක් කරන්න...',
  filterByStatus: 'තත්ත්වය අනුව පෙරන්න',
  filterByPayment: 'ගෙවීම අනුව පෙරන්න',
  filterByShop: 'වෙළඳසැල අනුව පෙරන්න',
  filterByCashier: 'මුදල් අයකැමි අනුව පෙරන්න',
  dateFrom: 'සිට',
  dateTo: 'දක්වා',
  dateRange: 'දින පරාසය',
  searchOrders: 'ඇණවුම් අංකයෙන් සොයන්න...',
  searchOrdersPlaceholder: 'ඇණවුම් #, ගනුදෙනුකරු නම, දුරකථනය සොයන්න...',
  filterByCustomer: 'ගනුදෙනුකරු අනුව පෙරන්න',
  filterBySession: 'සැසිය අනුව පෙරන්න',
  allCashiers: 'සියලුම මුදල් අයකැමියන්',
  selectSession: 'සැසිය තෝරන්න',
  selectDateRangeFirst: 'මුලින්ම දින පරාසයක් තෝරන්න',
  noSessionsFound: 'සැසි හමු නොවීය',
  searchSessions: 'සැසි සොයන්න...',

  status_completed:          'සම්පූර්ණ',
  status_voided:             'අවලංගු',
  status_on_hold:            'රඳවා ගත',
  status_credit:             'ණය',
  status_returned:           'ආපසු',
  status_partially_returned: 'අර්ධ ආපසු',

  status_applied:   'අයදුම් කළා',
  status_delivered: 'භාර දුන්නා',

  payment_paid:    'ගෙවා ඇත',
  payment_partial: 'අර්ධ',
  payment_unpaid:  'නොගෙවූ',

  refundMethod_cash:           'මුදල්',
  refundMethod_credit_note:    'ණය සටහන',
  refundMethod_loyalty_points: 'විශ්වාසී ලකුණු',

  bank_transfer: 'බැංකු හුවමාරුව',
  cash: 'මුදල්',
  card: 'කාඩ්පත',
  payzy: 'Payzy',
  orderNumberCol: 'ඇණවුම් #',
  customerCol: 'ගනුදෙනුකරු',
  cashierCol: 'මුදල් අයකැමි',
  totalCol: 'එකතුව',
  paidCol: 'ගෙවා ඇත',
  balanceCol: 'ශේෂය',
  statusCol: 'තත්ත්වය',
  paymentStatusCol: 'ගෙවීම',
  actionsCol: 'ක්‍රියා',
  viewOrder: 'බලන්න',
  voidOrder: 'අවලංගු කරන්න',
  processReturn: 'ආපසු දෙන්න',
  recordPayment: 'ගෙවීම වාර්තා කරන්න',
  printReceiptAction: 'රිසිට්පත මුද්‍රණය කරන්න',

  statusCompleted: 'සම්පූර්ණ',
  statusVoided: 'අවලංගු',
  statusOnHold: 'රඳවා ගත',
  statusCredit: 'ණය',
  statusReturned: 'ආපසු',
  statusPartiallyReturned: 'අර්ධ ආපසු',
  paymentPaid: 'ගෙවා ඇත',
  paymentPartial: 'අර්ධ',
  paymentUnpaid: 'නොගෙවූ',

  voidOrderTitle: 'ඇණවුම අවලංගු කරන්න',
  voidReason: 'අවලංගු කිරීමට හේතුව',
  voidReasonPlaceholder: 'හේතුව ඇතුළත් කරන්න...',
  confirmVoid: 'අවලංගු කිරීම තහවුරු කරන්න',
  voidWarning: 'මෙම ක්‍රියාව ආපසු හැරවිය නොහැක. තොග ප්‍රතිස්ථාපනය කරනු ලැබේ.',

  processReturnTitle: 'ආපසු ගෙවීම සකසන්න',
  returnItems: 'ආපසු දෙන අයිතම',
  returnQty: 'ආපසු ප්‍රමාණය',
  available: 'තිබෙන ප්‍රමාණය',
  refundAmount: 'ආපසු ගෙවීමේ මුදල',
  refundMethod: 'ආපසු ගෙවීමේ ක්‍රමය',
  refundCash: 'මුදල් ආපසු ගෙවීම',
  refundCreditNote: 'ණය සටහන',
  refundLoyaltyPoints: 'පක්ෂපාතී ලකුණු',
  returnReason: 'ආපසු දීමට හේතුව',
  confirmReturn: 'ආපසු දීම තහවුරු කරන්න',
  totalRefund: 'මුළු ආපසු ගෙවීම',

  recordCreditPayment: 'ගෙවීම වාර්තා කරන්න',
  outstandingBalance: 'ගෙවිය යුතු ශේෂය',
  amountToPayNow: 'දැන් ගෙවිය යුතු මුදල',
  confirmPayment: 'ගෙවීම තහවුරු කරන්න',

  allPosCustomers: 'දුරස්ථ විකුණුම් ගනුදෙනුකරුවන්',
  addCustomer: 'ගනුදෙනුකරු එකතු කරන්න',
  editCustomer: 'ගනුදෙනුකරු සංස්කරණය කරන්න',
  importCustomers: 'ආයාත කරන්න',
  backToCustomers: 'ගනුදෙනුකරුවන් වෙත ආපසු',
  customerNotes: 'සටහන්',
  customerSecondaryPhone: 'ද්විතීයික දුරකථනය',
  totalSpend: 'මුළු වියදම',
  viewHistory: 'ඉතිහාසය බලන්න',
  purchaseHistory: 'මිලදී ගැනීමේ ඉතිහාසය',
  noPurchaseHistory: 'මිලදී ගැනීමේ ඉතිහාසයක් නැත',
  activeCustomer: 'ක්‍රියාකාරී',
  inactiveCustomer: 'අක්‍රීය',

  importStep1Title: 'ආදර්ශ ගොනුව බාගන්න',
  importStep1Desc: 'Excel ආදර්ශ ගොනුව බාගන්න, ඔබේ ගනුදෙනුකරු දත්ත පුරවා පහතින් උඩුගත කරන්න.',
  importStep2Title: 'ගොනුව උඩුගත කරන්න',
  importStep3Title: 'පෙරදසුන සහ ආයාතය',
  downloadTemplate: 'ආදර්ශ ගොනුව බාගන්න',
  dropZoneText: 'ඔබේ ගොනුව මෙහි ඇද දමන්න, හෝ බ්‍රවුස් කිරීමට ක්ලික් කරන්න',
  dropZoneSub: '.xlsx, .xls, .csv සඳහා සහාය දක්වයි — උපරිම පේළි 1,000',
  rowsFound: 'පේළි හමු විය',
  previewShowing: 'පේළි {{total}} න් පළමු {{shown}} පෙන්වයි',
  andMoreRows: '...තවත් පේළි {{count}}ක්',
  importing: 'ආයාත කරමින්...',
  importNCustomers: 'ගනුදෙනුකරුවන් {{count}} ආයාත කරන්න',
  importComplete: 'ආයාතය සම්පූර්ණයි',
  importedCustomers: 'ආයාත කරන ලද',
  updatedCustomers: 'යාවත්කාලීන කළ',
  exportCustomers: 'අපනයනය',
  exporting: 'අපනයනය කරමින්...',
  skippedRows: 'මඟ හැරුණු',
  importErrors: 'දෝෂ',
  rowLabel: 'පේළිය',
  importAnother: 'තවත් ගොනුවක් ආයාත කරන්න',

  cashierSessions: 'මුදල් අයකැමි සැසි',
  openNewSession: 'නව සැසිය විවෘත කරන්න',
  activeSession: 'ක්‍රියාකාරී සැසිය',
  noActiveSession: 'ක්‍රියාකාරී සැසියක් නැත',
  closedAt: 'වසන ලද වේලාව',
  openedAt: 'විවෘත කළ වේලාව',
  closingCash: 'අවසාන මුදල්',
  sessionNotes: 'සටහන්',
  viewZReport: 'Z-වාර්තාව බලන්න',
  zReport: 'Z-වාර්තාව',
  zReportTitle: 'සැසි අවසාන වාර්තාව',
  totalSales: 'මුළු විකුණුම්',
  storePickupPayments: 'Store Pickup ගෙවීම්',
  categoryWiseSales: 'කාණ්ඩ අනුව විකුණුම්',
  categoryOther: 'වෙනත්',
  salesCount: 'විකුණුම් ගණන',
  paymentBreakdown: 'ගෙවීම් වර්ගීකරණය',
  voidSummary: 'අවලංගු කිරීම්',
  returnSummary: 'ආපසු දීම්',
  creditSummary: 'ණය ශේෂය',
  cashExpected: 'අපේක්ෂිත මුදල්',
  cashVariance: 'වෙනස',
  selectCashier: 'මුදල් අයකැමි තෝරන්න',
  createSession: 'සැසිය සාදන්න',
  sessionSummary: 'සැසි සාරාංශය',
  closingAmounts: 'අවසාන මුදල් (ක්‍රමය අනුව ගණන් කළ මුදල ඇතුළත් කරන්න)',
  totalVariance: 'මුළු වෙනස',
  statusOpen: 'විවෘත',
  statusClosed: 'වසා ඇත',

  posSettingsDesc: 'ඔබේ දුරස්ථ විකුණුම් වෙළඳසැල් සඳහා පක්ෂපාතී වැඩසටහන සහ රිසිට්පත් සැකැස්ම වින්‍යාස කරන්න.',
  loyaltySettings: 'පක්ෂපාතී වැඩසටහන',
  enableLoyalty: 'පක්ෂපාතී ලකුණු සක්‍රීය කරන්න',
  enableLoyaltyHint: 'ගනුදෙනුකරුවන් මිලදී ගැනීම් මත ලකුණු උපයනු ලබන අතර ඒවා වට්ටම් ලෙස මුදාහැරිය හැක.',
  pointsPerRupee: 'රුපියලකට උපයන ලකුණු',
  pointsPerRupeeHint: 'රු. 1කට උපයන ලකුණු ගණන',
  pointValueRupees: 'එක් ලකුණකට වටිනාකම (රු.)',
  pointValueHint: 'මුදාහරින විට එක් පක්ෂපාතී ලකුණක රුපියල් වටිනාකම',
  minRedeemPoints: 'මුදාහැරීමට අවම ලකුණු',
  minRedeemHint: 'ගනුදෙනුකරුවෙකුට මුදාහැරීමට පෙර අවශ්‍ය අවම ලකුණු',
  maxRedeemPct: 'උපරිම මුදාහැරීම (ඇණවුමෙන් %)',
  maxRedeemHint: 'ලකුණු හරහා වට්ටම් කළ හැකි ඇණවුම් මුළු එකතුවෙන් උපරිම %',
  receiptSettings: 'රිසිට්පත් සැකසුම්',
  receiptHeader: 'රිසිට්පත ශීර්ෂය',
  receiptFooter: 'රිසිට්පත පාදකය',
  receiptHeaderPlaceholder: 'ශීර්ෂ පෙළ ඇතුළත් කරන්න (උදා: වෙළඳසැල් ලිපිනය, ස්තුති පණිවිඩය)',
  receiptFooterPlaceholder: 'පාදක පෙළ ඇතුළත් කරන්න (උදා: ආපසු ගැනීමේ ප්‍රතිපත්තිය)',
  saveSettings: 'සැකසුම් සුරකින්න',

  auditHistory: 'විගණන ඉතිහාසය',

  cartEmpty: 'කරත්තය හිස්ය',
  sessionRequiredError: 'කරුණාකර පළමුව මුදල් අයකැමි සැසියක් විවෘත කරන්න',
  insufficientLoyaltyPoints: 'ප්‍රමාණවත් පක්ෂපාතී ලකුණු නොමැත',
  creditNotAllowed: 'මෙම වෙළඳසැල හෝ ගනුදෙනුකරු සඳහා ණය විකුණුම් සඳහා අවසර නැත',

  paymentFee: 'ගාස්තුව',
  feeAbsorbed: 'ව්‍යාපාරය',
  feeChargedToCustomer: 'ගනුදෙනුකරු',
  totalPaymentFees: 'මුළු ගෙවීම් ගාස්තු',
  paymentFeesCustomer: 'ගාස්තු (ගනුදෙනුකරු)',

  shareInvoice: 'ඉන්වොයිස් බෙදා ගන්න',
  sendViaWhatsApp: 'WhatsApp',
  sendViaSms: 'SMS යවන්න',
  sendingInvoice: 'යවමින්…',
  smsSent: 'SMS යවන ලදී',

  productCostCol: 'පිරිවැය',
  paymentFeesCol: 'ගාස්තු',
  profitCol: 'ලාභය',
  totalProductCost: 'නිෂ්පාදන පිරිවැය',
  grossProfit: 'මළු ලාභය',

  // Create order page (new)
  createOfflineSalesOrder: 'දුරස්ථ විකුණුම් ඇණවුමක් සාදන්න',
  editOfflineSalesOrder: 'දුරස්ථ විකුණුම් ඇණවුම සංස්කරණය කරන්න',
  addNewOfflineOrder: 'කවුන්ටර, ණය හෝ කුරියර් මගින් සිදු කරන දුරස්ථ විකුණුමක් වාර්තා කරන්න',
  backToOrders: 'ඇණවුම් වෙත ආපසු',
  shopSelection: 'වෙළඳසැල තෝරාගැනීම',
  customerInformation: 'ගනුදෙනුකරු',
  orderItems: 'ඇණවුම් අයිතම',
  fulfillmentMethod: 'භාරදීමේ ක්‍රමය',
  counterPickup: 'කවුන්ටරයෙන් ලබාගැනීම',
  selfDelivery: 'ස්වයං බෙදාහැරීම',
  courier: 'කුරියර්',
  paymentDetails: 'ගෙවීම් විස්තර',
  addPayment: 'ගෙවීමක් එකතු කරන්න',
  paymentMethod: 'ගෙවීමේ ක්‍රමය',
  selectPaymentMethod: 'ගෙවීමේ ක්‍රමය තෝරන්න',
  amount: 'මුදල',
  reference: 'යොමුව',
  orderDiscount: 'ඇණවුම් වට්ටම',
  orderSummary: 'ඇණවුම් සාරාංශය',
  subtotal: 'උප එකතුව',
  discount: 'වට්ටම',
  tax: 'බදු',
  grandTotal: 'මුළු එකතුව',
  paidAmount: 'ගෙවූ මුදල',
  balanceAmount: 'ශේෂය (ණය)',
  notes: 'සටහන්',
  createOrder: 'ඇණවුම සාදන්න',
  someFieldsRequired: 'ඉදිරිපත් කිරීමට පෙර කරුණාකර සලකුණු කළ ක්ෂේත්‍ර නිවැරදි කරන්න',
  orderCreatedSuccess: 'ඇණවුම {orderNumber} සාර්ථකව සාදන ලදී',
  orderUpdatedSuccess: 'ඇණවුම සාර්ථකව යාවත්කාලීන කරන ලදී',
  failedToCreateOrder: 'ඇණවුම සෑදීමට අසමත් විය',

  creditLimitWarningTitle: 'ණය සීමාව ඉක්මවා ඇත',
  creditLimitWarningMessage: 'මෙම ගනුදෙනුකරුගේ ගෙවිය යුතු ශේෂය (මෙම ඇණවුම ඇතුළුව) ඔවුන්ගේ ණය සීමාව ඉක්මවයි. ඇණවුම තවමත් සාදන ලදී — තවදුරටත් ණය ලබා දීමට පෙර සමාලෝචනය කරන්න.',

  searchProducts: 'නිෂ්පාදන සොයන්න හෝ බාර්කෝඩ් ස්කෑන් කරන්න',
  noProductsFound: 'නිෂ්පාදන හමු නොවීය',
  removeItem: 'අයිතමය ඉවත් කරන්න',
  quantity: 'ප්‍රමාණය',
  unitPrice: 'ඒකක මිල',
  lineDiscount: 'වට්ටම',
  lineTotal: 'එකතුව',
  noItemsAdded: 'තවම අයිතම එකතු කර නැත',

  selectCustomer: 'ගනුදෙනුකරු තෝරන්න',
  searchCustomers: 'නම හෝ දුරකථන අංකයෙන් ගනුදෙනුකරුවන් සොයන්න',
  cashSales: 'මුදල් විකුණුම්',
  noCustomersFound: 'ගනුදෙනුකරුවන් හමු නොවීය',
  newCustomer: 'නව ගනුදෙනුකරු',
  customerName: 'ගනුදෙනුකරු නම',
  customerNamePlaceholder: 'ගනුදෙනුකරුගේ නම ඇතුළත් කරන්න',
  customerPhone: 'දුරකථනය',
  customerEmail: 'විද්‍යුත් තැපෑල',
  customerEmailPlaceholder: 'විද්‍යුත් තැපැල් ලිපිනය ඇතුළත් කරන්න',
  customerAddress: 'ලිපිනය',
  customerAddressPlaceholder: 'ලිපිනය ඇතුළත් කරන්න',
  customerNotesPlaceholder: 'මෙම ගනුදෙනුකරු පිළිබඳ සටහන් එකතු කරන්න',
  creditLimit: 'ණය සීමාව',
  creditLimitPlaceholder: 'ණය සීමාව ඇතුළත් කරන්න',
  creditTermDays: 'ණය කාලසීමාව (දින)',
  creditTermDaysPlaceholder: 'ණය කාලසීමාව දින ගණන ඇතුළත් කරන්න',
  failedToCreateCustomer: 'ගනුදෙනුකරු සෑදීමට අසමත් විය',
  customerCreatedSuccess: 'ගනුදෙනුකරු සාර්ථකව සාදන ලදී',
  changeCustomer: 'වෙනස් කරන්න',
  salesRep: 'විකුණුම් නියෝජිත',
  selectSalesRep: 'විකුණුම් නියෝජිතයෙකු තෝරන්න',
  assignSalesRep: 'විකුණුම් නියෝජිත පවරන්න',
  salesRepAssigned: 'විකුණුම් නියෝජිත යාවත්කාලීන කරන ලදී',
  salesRepAssignFailed: 'විකුණුම් නියෝජිත යාවත්කාලීන කිරීම අසාර්ථකයි',
  salesRepSettings: 'විකුණුම් නියෝජිතයන්',
  salesRepRoles: 'විකුණුම් නියෝජිත භූමිකා',
  salesRepRolesPlaceholder: 'සියලුම පරිශීලකයන්',
  salesRepRolesHint: 'නොබැඳි ඇණවුම්වල විකුණුම් නියෝජිතයන් ලෙස තෝරාගත හැක්කේ මෙම භූමිකාවල පරිශීලකයන් පමණි. කිසිවක් තෝරා නොමැති නම්, සියලුම පරිශීලකයන් පෙන්වයි.',

  // Customer location picker
  customerLocation: 'Location', // TODO: si translation
  locationSearchPlaceholder: 'ශ්‍රී ලංකාවේ ස්ථානයක් සොයන්න',
  locationSearchButton: 'සොයන්න',
  locationSearchNoResults: 'ප්‍රතිඵල හමු නොවීය',
  locationUseMyLocation: 'මගේ වත්මන් ස්ථානය භාවිත කරන්න',
  locationDetecting: 'ඔබේ ස්ථානය හඳුනාගනිමින්...',
  locationPermissionDenied: 'ස්ථාන අවසරය ප්‍රතික්ෂේප විය. කරුණාකර ස්ථාන ප්‍රවේශය ඉඩ දෙන්න හෝ සිතියමේ තෝරන්න.',
  locationUnavailable: 'ඔබේ ස්ථානය තීරණය කළ නොහැකි විය. කරුණාකර සිතියමේ තෝරන්න.',
  locationTimeout: 'ස්ථාන ඉල්ලීම කාලය ඉකුත් විය. නැවත උත්සාහ කරන්න හෝ සිතියමේ තෝරන්න.',
  locationNotSupported: 'ඔබේ බ්‍රවුසරය ස්ථාන හඳුනාගැනීම සඳහා සහාය නොදක්වයි. කරුණාකර සිතියමේ තෝරන්න.',
  locationNearbyAddress: 'ආසන්න ලිපිනය',
  locationNearbyAddressUnavailable: 'මෙම ස්ථානය සඳහා ආසන්න ලිපිනයක් සොයාගත නොහැකි විය',
  locationGoogleLinkLabel: 'හෝ Google Maps සබැඳියක් අලවන්න',
  locationGoogleLinkPlaceholder: 'Google Maps සබැඳිය අලවන්න',
  locationUseLinkButton: 'සබැඳිය භාවිත කරන්න',
  locationGoogleLinkInvalid: 'මෙම සබැඳියෙන් ඛණ්ඩාංක කියවිය නොහැකි විය',
  locationLatitude: 'අක්ෂාංශය',
  locationLongitude: 'දේශාංශය',
  locationClear: 'ස්ථානය ඉවත් කරන්න',

  receivablesDescription: 'ණය සහ අර්ධ වශයෙන් ආපසු දුන් දුරස්ථ විකුණුම්වලින් ගෙවිය යුතු ගනුදෙනුකරු ශේෂ',
  totalOutstanding: 'මුළු ගෙවිය යුතු මුදල',
  customer: 'ගනුදෙනුකරු',
  phone: 'දුරකථනය',
  aging0to30: 'දින 0-30',
  aging31to60: 'දින 31-60',
  aging61to90: 'දින 61-90',
  aging90plus: 'දින 90+',
  noReceivablesFound: 'ගෙවිය යුතු මුදල් නොමැත',
  noReceivablesFoundDescription: 'සියලුම දුරස්ථ විකුණුම් ගනුදෙනුකරු ශේෂ පියවා ඇත',
  failedToLoadReceivables: 'ලැබිය යුතු මුදල් පූරණය කිරීමට අසමත් විය',
  searchByCustomerName: 'ගනුදෙනුකරු නම හෝ දුරකථනයෙන් සොයන්න',

  // Session gate / packing (shared, Stage 8 groundwork)
  warehouse: 'ගබඩාව',
  sessionRequiredTitle: 'මුදල් අයකැමි සැසිය අවශ්‍යයි',
  sessionLoading: 'මුදල් අයකැමි සැසිය පරීක්ෂා කරමින්...',
  sessionNotFound: 'ඇණවුමක් සෑදීමට පෙර මෙම වෙළඳසැල සඳහා මුදල් අයකැමි සැසියක් විවෘත කරන්න',
  customerStatement: 'ගනුදෙනුකරු ප්‍රකාශනය',
  openingBalance: 'ආරම්භක ශේෂය',
  closingBalance: 'අවසාන ශේෂය',
  type: 'වර්ගය',
  transactionType_invoice: 'ඉන්වොයිසිය',
  transactionType_payment: 'ලැබුණු ගෙවීම',
  transactionType_credit_note: 'බැර සටහන',
  transactionType_return: 'මුදල් ආපසු ගෙවීම',
  debit: 'ණය',
  credit: 'බැර',
  selectDateRange: 'දින පරාසය තෝරන්න',
  noTransactionsFound: 'ගනුදෙනු හමු නොවීය',
  noTransactionsFoundDescription: 'තෝරාගත් දින පරාසය තුළ ගනුදෙනු නොමැත',
  paymentRecordedSuccess: 'ගෙවීම සාර්ථකව සටහන් විය',
  failedToRecordPayment: 'ගෙවීම සටහන් කිරීමට අසමත් විය',
  creditNotePaymentMethod: 'Credit Note',
  selectCreditNote: 'Select Credit Note',
  searchCreditNote: 'Search credit notes...',
  noAvailableCreditNotes: 'No available credit notes',
  applyCreditNotePayment: 'Apply Credit Note',
  offlinePacking: 'ඔෆ්ලයින් කුරියර් පැකින්',
  offlinePackingDescription: 'කුරියර් මගින් සපයන ඔෆ්ලයින් ඇණවුම් යැවීම සඳහා සකස් කරන්න',
  viewMixedPackingQueue: 'මිශ්‍ර පෝලිම බලන්න',
  offlinePackingBatchList: 'ඔෆ්ලයින් කුරියර් පැකින් කණ්ඩායම්',
  offlinePackingBatchListDescription: 'සියලුම ඔෆ්ලයින් කුරියර් පැකින් කණ්ඩායම් බලන්න සහ කළමනාකරණය කරන්න',
  courierAccount: 'කුරියර් ගිණුම',
  selectCourierAccount: 'කුරියර් ගිණුමක් තෝරන්න',
  searchPackingOrders: 'ඇණවුම් අංකය හෝ ගනුදෙනුකරු සොයන්න',
  failedToLoadPackingReferences: 'පැකින් යොමු පූරණය කිරීමට අසමත් විය',
  selectPackingReferences: 'මුලින්ම ගබඩාවක් සහ කුරියර් ගිණුමක් තෝරන්න',
  failedToLoadPackingOrders: 'ඔෆ්ලයින් කුරියර් ඇණවුම් පූරණය කිරීමට අසමත් විය',
  selectPackingOrders: 'අවම වශයෙන් එක් ඇණවුමක් තෝරන්න',
  packingBatchCreated: 'පැකින් කණ්ඩායම සාර්ථකව සාදන ලදී',
  failedToCreatePackingBatch: 'පැකින් කණ්ඩායම සෑදීමට අසමත් විය',
  selectPackingOrder: 'ඇණවුම {orderNumber} තෝරන්න',
  selectedPackingOrders: 'ඇණවුම් {count} ක් තෝරා ඇත',
  createPackingBatch: 'පැකින් කණ්ඩායමක් සාදන්න',
  noPackingOrders: 'ඔෆ්ලයින් කුරියර් ඇණවුම් හමු නොවීය',
  noPackingOrdersDescription: 'සුදුසුකම් ලබන ඇණවුම් සොයා ගැනීමට ගබඩාවක් සහ කුරියර් ගිණුමක් තෝරන්න',
  // Order audit history
  auditEmpty: "හිස්",
  auditBy: "{{name}} විසින්",
  audit_CREATE: "ඇණවුම සාදන ලදී",
  audit_UPDATE: "ඇණවුම යාවත්කාලීන කරන ලදී",
  audit_STATUS_CHANGE: "තත්ත්වය වෙනස් විය",
  audit_DELETE: "ඉවත් කරන ලදී",
  audit_payment_CREATE: "ගෙවීම වාර්තා කරන ලදී",
  audit_payment_UPDATE: "ගෙවීම යාවත්කාලීන කරන ලදී",
  audit_payment_DELETE: "ගෙවීම ඉවත් කරන ලදී",
  audit_payment_customer_payment_applied: "පාරිභෝගික ගෙවීම යොදන ලදී",
  audit_payment_customer_payment_voided: "පාරිභෝගික ගෙවීම අවලංගු කරන ලදී",
  audit_payment_cheque_bounced: "චෙක්පත ප්‍රතික්ෂේප විය",
  audit_quotation_CONVERTED: "මිල ගණනයෙන් පරිවර්තනය කරන ලදී",
  audit_order_items_UPDATED: "ඇණවුම් අයිතම යාවත්කාලීන කරන ලදී",
  audit_order_items_CREATED: "ඇණවුම් අයිතම එක් කරන ලදී",
  audit_delivery_note_CREATED: "බෙදාහැරීම් සටහන සාදන ලදී",
  audit_return_note_CREATED: "ආපසු ලබාදීමේ සටහන සාදන ලදී",
  audit_return_note_VOIDED: "ආපසු ලබාදීමේ සටහන අවලංගු කරන ලදී",
  audit_credit_note_ISSUED: "ණය සටහන නිකුත් කරන ලදී",
  audit_credit_note_APPLIED: "ණය සටහන යොදන ලදී",
  audit_credit_note_CANCELLED: "ණය සටහන අවලංගු කරන ලදී",
  auditTag_payment: "ගෙවීම් වාර්තාව",
  auditTag_quotation: "මිල ගණනය",
  auditTag_order_items: "ඇණවුම් අයිතම",
  auditTag_delivery_note: "බෙදාහැරීම් සටහන",
  auditTag_return_note: "ආපසු ලබාදීමේ සටහන",
  auditTag_credit_note: "ණය සටහන",
  auditItemAdded: "එකතු කරන ලදී",
  auditItemRemoved: "ඉවත් කරන ලදී",
  auditItemUpdated: "යාවත්කාලීන කරන ලදී",
  auditField_orderStatus: "ඇණවුම් තත්ත්වය",
  auditField_status: "තත්ත්වය",
  auditField_quantity: "ප්‍රමාණය",
  freeUnits: "නොමිලේ",
  freeUnitsHint: "නොමිලේ ලබාදෙන ඒකක (ප්‍රමාණයට ඇතුළත්)",
  showFreeUnits: "නොමිලේ ඒකක එක් කරන්න",
  freeUnitsCustom: "වෙනත් ප්‍රමාණය",
  freeUnitsApply: "යොදන්න",
  itemsIncludedFree: "නොමිලේ අයිතම {{count}}ක් ඇතුළත්",
  totalDiscountLabel: "මුළු Rs. {{total}}",
  inclFreeValue: "නොමිලේ {{count}} සඳහා Rs. {{value}} ඇතුළත්",
  auditField_freeQuantity: "නොමිලේ ඒකක",
  customerType: "පාරිභෝගික වර්ගය",
  selectCustomerType: "පාරිභෝගික වර්ගය තෝරන්න",
  customerCategory: "පාරිභෝගික කාණ්ඩය",
  selectCustomerCategory: "පාරිභෝගික කාණ්ඩය තෝරන්න",
  addCustomerCategory: "නව කාණ්ඩයක් එක් කරන්න",
  customerCategoryNamePlaceholder: "කාණ්ඩයේ නම ඇතුළත් කරන්න",
  customerCategoryCreated: "පාරිභෝගික කාණ්ඩය \"{name}\" සාදන ලදී",
  customerCategoryCreateFailed: "පාරිභෝගික කාණ්ඩය සෑදීමට අසමත් විය",
  tinNumber: "TIN අංකය",
  tinNumberPlaceholder: "TIN අංකය ඇතුළත් කරන්න",
  vatNumber: "VAT අංකය",
  vatNumberPlaceholder: "VAT අංකය ඇතුළත් කරන්න",
  auditField_unitPrice: "ඒකක මිල",
  auditField_lineDiscount: "පේළි වට්ටම",
  auditField_lineTotal: "පේළි එකතුව",
  auditField_refundMethod: "ආපසු ගෙවීමේ ක්‍රමය",
  auditField_totalRefundAmount: "ආපසු ගෙවීමේ මුදල",
  auditField_creditNoteNumber: "ණය සටහන",
  auditField_amount: "මුදල",
  auditField_appliedAmount: "යොදන ලද මුදල",
  auditField_sourceType: "මූලාශ්‍රය",
  auditField_receivedByName: "ලබාගත්තේ",
  auditField_notes: "සටහන්",
  // Customer payments, opening balances & cheques
  statusPending: 'පොරොත්තුවෙන්',
  statusInCourier: 'කුරියර් තුළ',
  transactionType_opening_balance: 'ආරම්භක ශේෂය',
  transactionType_customer_payment: 'ගනුදෙනුකරු ගෙවීම',
  transactionType_customer_payment_reversal: 'ගෙවීම ආපසු හැරවිණි',
  chqDetails: 'චෙක්පත් විස්තර',
  chqDate: 'චෙක්පත් දිනය',
  chqPostDated: 'පසු දින චෙක්පත',
  chqPostDatedHint: 'චෙක්පත අනාගත දිනයකට නම් සලකුණු කරන්න — එවිට චෙක්පත් දිනය අවශ්‍ය වේ',
  chqSelectDate: 'දිනය තෝරන්න',
  chqDateRequired: 'පසු දින චෙක්පතකට චෙක්පත් දිනය අවශ්‍යයි',
  chqDateMustBeFuture: 'පසු දින චෙක්පත් දිනය අදට පසු විය යුතුය',
  chqTitle: 'චෙක්පත්',
  chqDescription: 'ලැබුණු චෙක්පත් නිරීක්ෂණය කර අද තැන්පත් කළ හැකි ඒවා බලන්න',
  chqView_all: 'සියල්ල',
  chqView_depositable: 'දැන් තැන්පත් කළ හැකි',
  chqView_post_dated: 'පසු දින (නියමිත නොවූ)',
  chqView_deposited: 'තැන්පත් කළ',
  chqView_cleared: 'නිෂ්කාශිත',
  chqView_bounced: 'ප්‍රතික්ෂේපිත',
  chqStatus_pending: 'පොරොත්තුවෙන්',
  chqStatus_deposited: 'තැන්පත් කළ',
  chqStatus_cleared: 'නිෂ්කාශිත',
  chqStatus_bounced: 'ප්‍රතික්ෂේපිත',
  chqView_cancelled: 'අවලංගු',
  chqStatus_cancelled: 'අවලංගු',
  chqMarkDeposited: 'තැන්පත් කළ ලෙස සලකුණු කරන්න',
  chqMarkCleared: 'නිෂ්කාශිත ලෙස සලකුණු කරන්න',
  chqMarkBounced: 'ප්‍රතික්ෂේපිත ලෙස සලකුණු කරන්න',
  chqBounceConfirm: 'මෙම චෙක්පත ප්‍රතික්ෂේපිත ලෙස සලකුණු කරන්නද? අදාළ ගෙවීම ආපසු හැරවෙනු ඇත.',
  chqDepositConfirm: 'මෙම චෙක්පත තැන්පත් කළ ලෙස සලකුණු කරන්නද?',
  chqStatusUpdated: 'චෙක්පත් තත්ත්වය යාවත්කාලීන විය',
  chqFailedToUpdate: 'චෙක්පත යාවත්කාලීන කිරීම අසාර්ථකයි',
  chqFailedToLoad: 'චෙක්පත් පූරණය අසාර්ථකයි',
  chqNotYetDue: 'තැන්පත් කිරීමට තවම නියමිත නැත',
  chqDueInDays: 'දින {days} කින් නියමිතයි',
  chqNotYetDueOn: '{date} දක්වා තැන්පත් කිරීමට නියමිත නැත (දින {days} ක් ඉතිරිය)',
  cpPaymentDate: 'ගෙවීම් දිනය',
  cpReference: 'යොමුව',
  cpProof: 'ගෙවීම් සාක්ෂිය',
  cpViewProof: 'සාක්ෂිය බලන්න',
  cpViewFile: 'ගොනුව බලන්න',
  cpView: 'ගෙවීම බලන්න',
  cpFilterCustomer: 'පාරිභෝගිකයා',
  cpFilterMethod: 'ගෙවීම් ක්‍රමය',
  cpDetailTitle: 'පාරිභෝගික ගෙවීම',
  cpAllocations: 'යොදන ලද්දේ',
  cpAllocatedTo: 'ඉන්වොයිසිය / ශේෂය',
  cpAsOfDate: 'දිනට',
  cpInvoiceTotal: 'ඉන්වොයිස් එකතුව',
  cpAmountApplied: 'යොදන ලද මුදල',
  cpReceivedBy: 'ලබාගත්තේ',
  cpNoAllocations: 'මෙම ගෙවීම කිසිදු ශේෂයකට යොදා නැත',
  chqPdcTag: 'පසු දින',
  chqLinkedTo: 'සම්බන්ධිත',
  chqCount: 'චෙක්පත් {count}',
  chqSearchPlaceholder: 'ගනුදෙනුකරු සොයන්න',
  chqDateRange: 'චෙක්පත් දින පරාසය',
  chqEmpty: 'චෙක්පත් හමු නොවීය',
  chqEmptyDescription: 'තෝරාගත් දර්ශනයට ගැළපෙන චෙක්පත් නැත',
  chqPdcInHand: 'අතැති චෙක්පත්',
  cpTitle: 'ගනුදෙනුකරු ගෙවීම්',
  cpDescription: 'ගනුදෙනුකරුවන්ගෙන් ලැබුණු ගෙවීම්, පැරණිතම ශේෂවලට ස්වයංක්‍රීයව යොදනු ලැබේ',
  cpReceivePayment: 'ගෙවීමක් ලබාගන්න',
  cpReceiveDescription: 'ඉන්වොයිසියක් නොතෝරා ගෙවීමක් සටහන් කරන්න — පළමුව ආරම්භක ශේෂයට, පසුව පැරණිතම ඉන්වොයිසිවලට',
  cpPaymentDetails: 'ගෙවීම් විස්තර',
  cpMethod: 'ගෙවීම් ක්‍රමය',
  cpNotes: 'සටහන්',
  cpSave: 'ගෙවීම සුරකින්න',
  cpSaved: 'ගනුදෙනුකරු ගෙවීම සටහන් විය',
  cpFailedToSave: 'ගෙවීම සටහන් කිරීම අසාර්ථකයි',
  cpFailedToLoad: 'ගනුදෙනුකරු ගෙවීම් පූරණය අසාර්ථකයි',
  cpFailedToPreview: 'හිඟ අයිතම පූරණය අසාර්ථකයි',
  cpSelectCustomerFirst: 'හිඟ ශේෂ බැලීමට ගනුදෙනුකරුවෙකු තෝරන්න',
  cpSelectMethod: 'ගෙවීම් ක්‍රමයක් තෝරන්න',
  cpAmountRequired: 'මුදල 0 ට වඩා වැඩි විය යුතුය',
  cpAllocationPreview: 'බෙදාහැරීමේ පෙරදසුන',
  cpFifoHint: 'පැරණිතම පළමුව: ආරම්භක ශේෂය, පසුව දිනය අනුව ඉන්වොයිසි',
  cpOutstanding: 'හිඟ',
  cpApplied: 'යොදන ලද',
  cpRemaining: 'ඉතිරි',
  cpNoOpenItems: 'හිඟ කිසිවක් නැත',
  cpNoOpenItemsDescription: 'මෙම ගනුදෙනුකරුට හිඟ ශේෂයක් නැත — ගෙවීම බැර ලෙස තබා ගනී',
  cpExistingCredit: 'පවතින නොබෙදූ බැර',
  cpWillBeCredit: '{amount} ගනුදෙනුකරු බැර ලෙස තබා ගනී',
  cpNumber: 'රිසිට් අංකය',
  cpUnallocated: 'නොබෙදූ',
  cpUnallocatedCredit: 'නොබෙදූ බැර',
  cpAppliedTo: 'යොදන ලද්දේ',
  cpStatus_active: 'සක්‍රිය',
  cpStatus_void: 'අවලංගු',
  cpVoid: 'ගෙවීම අවලංගු කරන්න',
  cpVoidConfirm: '{number} ගෙවීම අවලංගු කරන්නද? එහි බෙදාහැරීම් ආපසු හැරවේ.',
  cpVoided: 'ගනුදෙනුකරු ගෙවීම අවලංගු විය',
  cpFailedToVoid: 'ගෙවීම අවලංගු කිරීම අසාර්ථකයි',
  cpSearchPlaceholder: 'රිසිට් අංකය, යොමුව හෝ ගනුදෙනුකරු සොයන්න',
  cpEmpty: 'තවම ගනුදෙනුකරු ගෙවීම් නැත',
  cpEmptyDescription: '"ගෙවීමක් ලබාගන්න" මගින් ලැබුණු ගෙවීම් මෙහි දිස්වේ',
  obAmount: 'ආරම්භක ශේෂ මුදල',
  obAsOfDate: 'දිනට',
  obDateRequired: 'දිනය අවශ්‍යයි',
  obAmountRequired: 'දිනයක් ඇත්නම් ආරම්භක ශේෂය අවශ්‍යයි',
  cusCode: 'පාරිභෝගික කේතය',
  cusCodePlaceholder: 'හිස් නම් ස්වයංක්‍රීයව සාදයි',
  cusCodeExists: 'මෙම පාරිභෝගික කේතය දැනටමත් භාවිතයේ ඇත',
  cusCodeInvalid: 'අකුරු, ඉලක්කම් සහ ඉරි පමණක් භාවිතා කරන්න (උපරිම 20)',
  nameRequired: 'පාරිභෝගික නම අවශ්‍යයි',
  invalidPhone: 'වලංගු දුරකථන අංකයක් ඇතුළත් කරන්න',
  phoneExists: 'මෙම දුරකථන අංකය සහිත පාරිභෝගිකයෙක් දැනටමත් සිටී',
  secondarySameAsPrimary: 'ද්විතීයික දුරකථනය ප්‍රාථමික අංකයට වඩා වෙනස් විය යුතුය',
  invalidEmail: 'වලංගු ඊමේල් ලිපිනයක් ඇතුළත් කරන්න',
  mustBeNonNegative: '0 හෝ ඊට වැඩි විය යුතුය',
  mustBeWholeNumber: '0 හෝ ඊට වැඩි පූර්ණ සංඛ්‍යාවක් විය යුතුය',
  obDateFuture: 'දිනය අනාගත දිනයක් විය නොහැක',
  obLocked: 'මෙම ශේෂයට {paid} දැනටමත් ගෙවා ඇත — සංස්කරණයට එම ගෙවීම් අවලංගු කරන්න',
};
